import React, { PureComponent } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import "./editor-datePicker.css";
import moment from "moment";
import "moment/locale/uk.js";
import "moment/locale/ru.js";
import { withTranslation } from "react-i18next";
import timezoneDbApi from "../../api/timezonedb-api";

class EditorDatePicker extends PureComponent {
  constructor(props) {
    super(props);
    //moment.locale('uk');
    this.state = {
      isTimePickerAllowed: false,
    };

    this.timeZoneResponse = null;
    this.hasTime = this.state.isTimePickerAllowed;
    try {
        this.currentLocalDateTime = moment(this.props.date);
        this.currentUtcOffset = this.currentLocalDateTime.utcOffset();
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  }

  componentDidMount() {
    this.recalculateUtcOnDateUpdate();
  }
  componentDidUpdate(prevProps) {
    console.log("latitude:", this.props.latitude);

    console.log("longitude:", this.props.longitude);

    if (
      prevProps.latitude !== this.props.latitude ||
      prevProps.longitude !== this.props.longitude
    ) {
      this.recalculateUtcOnCoordinatesUpdate();
    }
  }

  raiseDateUpdate(timeZoneResponse) {
    this.timeZoneResponse = timeZoneResponse;

    if (timeZoneResponse.status === "FAILED") {
      // Location at sea inferred from longitude
        this.currentUtcOffset = Math.round(this.props.longitude / 15) * 60;
    } else {
        this.currentUtcOffset = timeZoneResponse.gmtOffset / 60;
      }
      var utcDateTime = this.getUtcTimeFromLocal();
      this.props.onDateChanged(this.currentLocalDateTime, utcDateTime, this.hasTime);
  }

    getUtcTimeFromLocal() {
        console.log("timezone offset:", this.currentUtcOffset);
        let utcDateTimeString = this.currentLocalDateTime.clone().add(- this.currentUtcOffset, 'minutes').format("YYYY-MM-DDTHH:mm:ss");
        let utcDateTime = moment.utc(utcDateTimeString);
        console.log("utc time:", utcDateTime);
        return utcDateTime;
    }
  
  recalculateUtcOnCoordinatesUpdate() {
    console.log("recalculateUtcOnCoordinatesUpdate");
      var timeStamp = this.currentLocalDateTime.unix();

    timezoneDbApi
      .getTimeZoneOffset(this.props.latitude, this.props.longitude, timeStamp)
      .then((r) => {
        if (
          this.timeZoneResponse &&
          r &&
          this.timeZoneResponse.zoneName === r.zoneName
        ) {
          console.log(
            "no need to raiseDateUpdate because timezone wasnt changed"
          );
        } else {
          this.raiseDateUpdate(r);
        }
      })
      .catch((e) => {
          (console.error || console.log).call(console, e.stack || e);
          var utcDateTime = this.getUtcTimeFromLocal();
          this.props.onDateChanged(this.currentLocalDateTime, utcDateTime, this.hasTime);
      });
  }

  recalculateUtcOnDateUpdate() {
    console.log("recalculateUtcTime");
      var timeStamp = this.currentLocalDateTime.unix();
    if (this.timeZoneResponse) {
      if (
        timeStamp >= this.timeZoneResponse.zoneStart &&
        timeStamp <= this.timeZoneResponse.zoneEnd
      ) {
        console.log("no need to get new timezone info");
        this.raiseDateUpdate(this.timeZoneResponse);
        return;
      }
    }

      timezoneDbApi
          .getTimeZoneOffset(this.props.latitude, this.props.longitude, timeStamp)
      .then((r) => {
        this.raiseDateUpdate(r);
      })
      .catch((e) => {
          (console.error || console.log).call(console, e.stack || e);
          var utcDateTime = this.getUtcTimeFromLocal();
          this.props.onDateChanged(this.currentLocalDateTime, utcDateTime, this.hasTime);
      });
  }

  onChange = (dateTime) => {
    console.log("selected dateTime:", dateTime);
    let hasTime = false;

    //date.utcOffset(0);
    try {
      if (dateTime && typeof dateTime === "string") {
        var dateTimeSplit = dateTime.match(
          /^\s*(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s+(\d{1,2})\:(\d{1,2}))?\s*$/
        );

        if (dateTimeSplit) {
          dateTimeSplit = dateTimeSplit.map((item) => {
            if (item && item.length == 1) {
              item = "0" + item;
            }
            return item;
          });

          dateTime = dateTimeSplit.slice(1, 4).join(".");

          if (
            dateTimeSplit.length >= 6 &&
            dateTimeSplit[4] &&
            dateTimeSplit[5]
          ) {
            hasTime = true;
            dateTime += " " + dateTimeSplit.slice(4, 6).join(":");
          }
          console.log("fixedDate:", dateTime);
        }

        dateTime = moment(dateTime, "DD.MM.YYYY HH:mm");
        if (!dateTime.isValid()) {
          throw "invalid date: " + dateTime;
        }
      } else {
        hasTime = this.state.isTimePickerAllowed;
      }

      // if (!this.state.isTimePickerAllowed) {
      //   dateTime.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      // }

        this.currentLocalDateTime = dateTime;
      this.hasTime = hasTime;

      this.recalculateUtcOnDateUpdate();
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
  };

  renderDateInput = (props, openCalendar, closeCalendar) => {
    return (
      <div class="input-group g-brd-primary--focus">
        <input
          {...(({ onClick, onFocus, ...rest }) => rest)(props)}
          class="form-control form-control-md u-datepicker-v1  rounded-0"
          type="text"
        />
        <div class="input-group-append">
          <button
            class="btn input-group-text rounded-0 g-bg-white g-color-gray-light-v1"
            type="button"
            onClick={openCalendar}
          >
            <i class="fa fa-calendar g-font-size-14"></i>
          </button>
        </div>

        {/* <div class="input-group-append">
          <span class="input-group-text rounded-0 g-color-gray-dark-v5">
            <i class="icon-calendar"></i>
          </span>
        </div> */}
      </div>
    );
  };

  onAllowTimePickerClick = () => {
    try {
      if (this.state.isTimePickerAllowed) {
          if (this.currentLocalDateTime) {
              this.currentLocalDateTime.set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          });
        }
      }
        var utcDateTime = this.getUtcTimeFromLocal();
        this.props.onDateChanged(
            this.currentLocalDateTime, utcDateTime,
        !this.state.isTimePickerAllowed
      );
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e);
    }
    this.setState({ isTimePickerAllowed: !this.state.isTimePickerAllowed });
  };

  render() {
    console.log("Rendering editor-datepicker");
    const { t, i18n } = this.props;
    return (
      <div class="form-group g-mb-10">
        <div class="d-flex flex-row justify-content-between align-items-start">
          <label class="g-mb-10">{t("Дата події")}</label>
          <button
            class={
              this.state.isTimePickerAllowed
                ? "btn btn-xs u-btn-primary"
                : "btn btn-xs u-btn-outline-primary"
            }
            onClick={this.onAllowTimePickerClick}
          >
            {t("Я знаю точний час")}
          </button>
        </div>

        <Datetime
          viewMode="years"
          locale={i18n.language}
          onChange={this.onChange}
          defaultValue={this.props.date}
          dateFormat="DD.MM.YYYY"
          timeFormat={this.state.isTimePickerAllowed ? "HH:mm" : false}
          closeOnSelect={true}
          renderInput={this.renderDateInput}
          inputProps={{
            placeholder: this.state.isTimePickerAllowed
              ? t("ДД.ММ.РРРР ГГ:ХХ")
              : t("ДД.ММ.РРРР"),
            inputMode: this.state.isTimePickerAllowed ? "text" : "numeric",
          }}
        ></Datetime>
      </div>
    );
  }
}

export default withTranslation()(EditorDatePicker);
